/**
 * Collection page interactivity. Filter checkboxes and pagination are
 * plain real links (url_to_add/url_to_remove) so they work with zero JS;
 * this file only adds: sort-select → URL navigation, the mobile filter
 * drawer, the price-range mini-form, and a stagger-reveal for the grid.
 */
import { revealOnScroll } from '@theme/premium-motion';

const sortSelect = document.querySelector('[data-flv-sort-select]');
sortSelect?.addEventListener('change', () => {
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', /** @type {HTMLSelectElement} */ (sortSelect).value);
  window.location.href = url.toString();
});

const priceForm = document.querySelector('[data-flv-price-form]');
if (priceForm instanceof HTMLFormElement) {
  priceForm.addEventListener('submit', (event) => {
    event.preventDefault();
    const minName = /** @type {HTMLInputElement} */ (priceForm.querySelector('[data-flv-price-min-name]')).name;
    const maxName = /** @type {HTMLInputElement} */ (priceForm.querySelector('[data-flv-price-max-name]')).name;
    const minValue = /** @type {HTMLInputElement} */ (priceForm.querySelector('[data-flv-price-min]')).value;
    const maxValue = /** @type {HTMLInputElement} */ (priceForm.querySelector('[data-flv-price-max]')).value;

    const url = new URL(window.location.href);
    minValue ? url.searchParams.set(minName, minValue) : url.searchParams.delete(minName);
    maxValue ? url.searchParams.set(maxName, maxValue) : url.searchParams.delete(maxName);
    window.location.href = url.toString();
  });
}

const filterPanel = document.querySelector('[data-flv-filter-panel]');
const filterOverlay = document.querySelector('[data-flv-filter-overlay]');
const filterToggle = document.querySelector('[data-flv-filter-toggle]');
const filterClose = document.querySelector('[data-flv-filter-close]');

if (filterPanel && filterOverlay) {
  const openFilters = () => {
    filterPanel.classList.add('flv-collection-grid__filters--open');
    filterOverlay.classList.add('flv-collection-grid__filter-overlay--visible');
  };
  const closeFilters = () => {
    filterPanel.classList.remove('flv-collection-grid__filters--open');
    filterOverlay.classList.remove('flv-collection-grid__filter-overlay--visible');
  };
  filterToggle?.addEventListener('click', openFilters);
  filterClose?.addEventListener('click', closeFilters);
  filterOverlay.addEventListener('click', closeFilters);
}

revealOnScroll('[data-flv-product-grid] .flv-product-card', { y: 24, scale: 0.97, duration: 0.6, stagger: 0.05 });
